import secureApi from "../services/secureApi";

export const getProfitSummary = async () => {
  const response = await secureApi.get("/admin/dashboard/profitSummary");
  return response.data;
};
